import React from "react";

export const NeutralSuccessIcon = (props) => (
  <svg width={props.width} height={props.height} viewBox="0 0 12 12" fill="none" xmlnsXlink="http://www.w3.org/2000/svg">
    <circle cx="6" cy="6" r="6" fill="#1C7ED6" />
    <circle cx="6" cy="6" r="1" fill="white" />
  </svg>
);
